import type { RemoteCartInfo } from '@@types'

export function computeCartTotalsBreakdown (
  cartInfo: RemoteCartInfo | null | undefined,
  isPickup: boolean,
) {
  const deliveryTotal = isPickup ? 0 : Number(cartInfo?.delivery?.total ?? 0)
  const deliverySale = isPickup ? 0 : Number(cartInfo?.delivery?.sale ?? 0)

  const effectiveTotal = Number(
    cartInfo?.totals?.effectiveTotal ?? cartInfo?.totals?.total ?? 0,
  )
  const orderTotal = effectiveTotal + deliveryTotal - deliverySale

  const salesByType: Record<string, { sale: number; amount: number }> = {}

  cartInfo?.sales?.forEach((saleItem) => {
    if (!salesByType[saleItem.type]) {
      salesByType[saleItem.type] = { sale: 0, amount: 0 }
    }

    salesByType[saleItem.type].sale += Number(saleItem.sale ?? 0)
    salesByType[saleItem.type].amount += Number(saleItem.amount ?? 0)
  })

  const positionTotalSale = salesByType['position-total']?.sale ?? 0
  const couponSale = salesByType.coupon?.sale ?? 0
  const bonusSale = salesByType.bonus?.sale ?? 0
  const bonusAmount = salesByType.bonus?.amount ?? 0
  const promocodeSale = salesByType.promocode?.sale ?? 0
  const yellowPriceSale = salesByType['yellow-price']?.sale ?? 0
  const couponBonusSale = salesByType['coupon-bonus']?.sale ?? 0
  const cashbackAmount = salesByType.cashback?.amount ?? 0

  // Loyalty discount = position-total minus all other discount types (like mobile app)
  const loyaltyDiscount = Math.max(
    0,
    positionTotalSale
      - couponSale
      - bonusSale
      - yellowPriceSale
      - promocodeSale
      - couponBonusSale
      - (salesByType.cashback?.sale ?? 0),
  )

  const hasSalesBreakdown =
    bonusSale > 0 ||
    couponSale > 0 ||
    promocodeSale > 0 ||
    loyaltyDiscount > 0 ||
    cashbackAmount > 0

  return {
    deliveryTotal,
    deliverySale,
    effectiveTotal,
    orderTotal,
    salesByType,
    positionTotalSale,
    couponSale,
    bonusSale,
    bonusAmount,
    promocodeSale,
    yellowPriceSale,
    couponBonusSale,
    cashbackAmount,
    loyaltyDiscount,
    hasSalesBreakdown,
  }
}
